/* Copyright (c) 2024 Xperi. All Rights Reserved.  */

export const SET_IS_STREAMING_RESTRICTED = 'SET_IS_STREAMING_RESTRICTED';
